import axios from 'axios';
import * as Config from '../../config';

const state = { };

const actions = {
    verify_password_afip_home_before({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'afip-contrasena/verify-password-afip-home-before', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    verify_password_afip_home({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'afip-contrasena/verify-password-afip-home', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_contrasena_nueva({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'afip-contrasena/nueva', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_contrasena_update({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'afip-contrasena/update', form)
                .then(
                    response => {
                        resolve(response);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};